export const mapResponse = ({data}) => (data.data ? data.data : data);

export default mapResponse;
